/**
 * Proof mosaic: tap-to-pause autoplay video, honor reduced motion.
 */
import "theme";

if (!window.customElements.get("proof-mosaic-video")) {
  class ProofMosaicVideo extends HTMLElement {
    connectedCallback() {
      if (this.__initialized) return;
      this.__initialized = true;

      this.media = this.querySelector("video-media");
      this.toggleButton = this.querySelector("[data-proof-mosaic-toggle]");
      if (!this.media) return;

      this.reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      this.allowPlay = !this.reduceMotion;

      if (this.reduceMotion) {
        this.media.removeAttribute("autoplay");
        this.media.pause();
        this.media.addEventListener("media:play", () => {
          if (!this.allowPlay) this.media.pause();
        });
      }

      this.addEventListener("click", (event) => {
        if (event.target.closest("a")) return;
        this.toggle();
      });
      this.syncLabel();
      this.media.addEventListener("media:play", () => this.syncLabel());
      this.media.addEventListener("media:pause", () => this.syncLabel());
    }

    toggle() {
      if (!this.media) return;
      this.allowPlay = true;
      if (this.media.playing) {
        this.media.pause();
      } else {
        this.media.play();
      }
    }

    syncLabel() {
      if (!this.toggleButton) return;
      const playing = Boolean(this.media?.playing);
      const label = playing
        ? this.toggleButton.dataset.pauseLabel
        : this.toggleButton.dataset.playLabel;
      if (label) this.toggleButton.setAttribute("aria-label", label);
      this.toggleButton.setAttribute("aria-pressed", playing ? "true" : "false");
    }
  }

  window.customElements.define("proof-mosaic-video", ProofMosaicVideo);
}